<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Employer'"
          :btnName="' Add New User'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/employers/create'"
          :btnPermission="'user.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        >
        </PageTitleWithSearch>
        <DataTableWithPagination
          v-if="employers"
          :headers="headers"
          :items="employers"
          :loading="loading"
          :page="page"
          :total="total"
          :totalItems="totalCustomer"
          @pageChange="onPageChange"
          dense
        >
          <template #row="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>{{ item.employee_no }}</td>
              <td class="text-left">
                {{ item.first_name }} {{ item.last_name }}
              </td>
              <td class="text-left">{{ item.state }}</td>
              <td class="text-left">{{ item.email }}</td>
              <td class="text-center" v-if="item.status">
                <v-chip
                  small
                  class="ma-2"
                  dark
                  :color="getStatusColor(item.status)"
                >
                  {{ stringFormatting(item.status) }}
                </v-chip>
              </td>
              <td class="text-center">
                <v-btn
                  v-if="hasPermission('user.edit')"
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/employers/edit/' + item.uuid"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800"> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  v-if="hasPermission('user.delete')"
                  class="my-1"
                  x-small
                  color="#FFCDD2"
                  @click="dropMemberConfirm(item.uuid)"
                  fab
                  style="box-shadow: none;"
                >
                  <v-icon dark small color="#F44336"> mdi-delete </v-icon>
                </v-btn>
                <v-btn
                  v-if="true"
                  class="my-1"
                  x-small
                  color="#00B3FF"
                  @click="reset2FA(item.uuid)"
                  fab
                  style="box-shadow: none;"
                  :title="'Reset 2FA'"
                >
                  <v-icon small color="#fff">mdi-lock-reset</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
      <!-- Pagination handled by DataTableWithPagination -->
    </v-card>

    <ConfirmModal
      :text="'Do you want to drop this employer?'"
      :title="'Drop Employer'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Snackbars from "@/components/shared/Snackbars";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { EmployerService } from "@/services/employer-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "CustomerGrid",
  components: {
    PageTitleWithSearch,
    ConfirmModal,
    Snackbars,
    DataTableWithPagination,
  },
  data: function() {
    return {
      employers: [],
      page: 1,
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalCustomer: 0,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      successMsg: "This client has incomplete jobs. Can not delete",
      defaultImage: require("@/assets/img/avatar.svg"),
      headers: [
        { text: "User ID", value: "emp_no", align: "left" },
        { text: "Name", value: "full_name", align: "left" },
        { text: "City", value: "suburb", align: "left" },
        { text: "Email", value: "email", align: "left" },
        { text: "Status", value: "status", align: "center" },
        { text: "Action", value: "actions", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getEmployer();
  },

  watch: {
    search() {
      this.page = 1;
      this.getEmployer();
    },
    page() {
      this.getEmployer();
    },
  },

  methods: {
    reset2FA(uuid) {
      this.loading = true;
      EmployerService.reset2FA(uuid)
        .then((response) => {
          this.loading = false;
          this.snackbar = true;
          this.successMsg = response.data.message || "2FA reset successfully.";
        })
        .catch((error) => {
          this.loading = false;
          this.snackbar = true;
          let data = error.response?.data;
          let errorOutput = checkError.errorFormatting(data);
          this.successMsg = errorOutput || "Failed to reset 2FA.";
        });
    },
    getEmployer() {
      this.loading = true;
      EmployerService.getEmployerList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.employers = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalCustomer = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.employers = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    onPageChange(newPage) {
      this.page = newPage;
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "ACTIVE":
          bgColor = "#A5D6A7";
          break;
        default:
          bgColor = "#EF9A9A";
          break;
      }

      return bgColor;
    },

    searchChange(value) {
      this.search = value;
    },

    canCreateEdit() {
      if (
        this.role === "ADMINISTRATOR" ||
        this.role === "MANAGER" ||
        this.role === "USER"
      ) {
        return true;
      } else {
        return false;
      }
    },

    dropMemberConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropMember();
    },

    dropMember() {
      if (this.dropId) {
        this.loading = true;
        EmployerService.dropMember(this.dropId)
          .then((response) => {
            if (response.data == "Success") {
              this.loading = false;
              this.getEmployer();
              this.snackbarColor = "success";
              this.successMsg = "User dropped successfully";
            } else {
              this.loading = false;
              this.snackbar = true;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    canDrop() {
      if (this.role === "ADMINISTRATOR") {
        return true;
      } else {
        return false;
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
